import {PROVINCES} from "../../constants/constants";


export default function provincesCountry(country){

   return  PROVINCES[country]?.map((province)=>{
        return {
            key: province.value,
            text: province.name,
            value: province.value}
    }
    ,[])

}